/**
 *
 * @module commerceManagerConfiguration
 *
 */

import ServiceConfiguration from './serviceConfiguration';

/**
 *
 * @class CommerceManagerConfiguration
 * @desc Provides configuration information necessary for managing commerce.
 *
 */
export default class CommerceManagerConfiguration extends ServiceConfiguration {}



// WEBPACK FOOTER //
// ./src/services/configuration/commerceManagerConfiguration.js